(function () {
  function parseJSON(str, fallback) {
    try { return JSON.parse(str); } catch (e) { return fallback; }
  }

  function findVariant(variants, selected) {
    return variants.find(function (v) {
      return v.options.every(function (val, i) { return selected[i] == null || selected[i] === val; });
    });
  }

  function initPicker(root) {
    if (root.dataset.cjVpInit) return;
    root.dataset.cjVpInit = '1';

    var variants = parseJSON(root.dataset.variants, []);
    var options = parseJSON(root.dataset.options, []);
    var stages = Array.prototype.slice.call(root.querySelectorAll('.cj-vp-stage'));
    var summary = root.querySelector('.cj-vp-summary');
    var hiddenInput = root.querySelector('.cj-vp-selected-variant');
    var selected = new Array(options.length).fill(null);

    function resolve() {
      if (!selected.every(function (v) { return v != null; })) return;
      var variant = findVariant(variants, selected);
      if (!variant) return;
      if (hiddenInput) hiddenInput.value = variant.id;
      root.dispatchEvent(new CustomEvent('cj-variant:change', { bubbles: true, detail: { variant: variant } }));
    }

    function renderSummary() {
      if (!summary) return;
      summary.innerHTML = '';
      selected.forEach(function (val, i) {
        if (val == null) return;
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'cj-vp-chip';
        chip.textContent = options[i].name + ': ' + val;
        chip.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          for (var j = i; j < selected.length; j++) selected[j] = null;
          stages.forEach(function (s, idx) {
            s.hidden = idx !== i;
            if (idx === i) {
              s.querySelectorAll('.cj-vp-circle').forEach(function (b) { b.classList.remove('active'); });
            }
          });
          renderSummary();
        });
        summary.appendChild(chip);
      });
    }

    function selectValue(idx, value, btn) {
      selected[idx] = value;
      stages[idx].querySelectorAll('.cj-vp-circle').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      renderSummary();

      var next = idx + 1;
      stages[idx].hidden = true;
      if (next < stages.length) stages[next].hidden = false;

      resolve();
    }

    stages.forEach(function (stage, idx) {
      stage.querySelectorAll('.cj-vp-circle').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          selectValue(idx, btn.dataset.value, btn);
        });
      });
    });

    if (options.length === 1 && stages.length === 1) {
      var firstBtn = stages[0].querySelector('.cj-vp-circle');
      if (firstBtn) selectValue(0, firstBtn.dataset.value, firstBtn);
    }
  }

  function initAll(context) {
    (context || document).querySelectorAll('.cj-vp').forEach(initPicker);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  initAll();
})();
